'use client'

import { ReactNode, useEffect, useRef } from 'react'

import { AirbridgeContext, useAirbridge } from '@/shared/config'
import { useSession } from '@/shared/lib'

export const AirbridgeProvider = ({ children }: { children: ReactNode }) => {
  const airbridge = useAirbridge()
  const { data: session } = useSession()

  const currentUserId = useRef<string | null>(null)

  useEffect(() => {
    if (!airbridge.isInitialized) {
      return
    }

    if (session?.aid && !currentUserId.current) {
      airbridge.setUser(session.aid)
      currentUserId.current = session.aid

      return
    }

    if (!session && currentUserId.current) {
      airbridge.clearUser()
      currentUserId.current = null
    }
  }, [airbridge, session])

  return (
    <AirbridgeContext.Provider value={airbridge}>
      {children}
    </AirbridgeContext.Provider>
  )
}
